import $ from 'jquery';

$.addInit(function(context) {
	var base = '.i-tabs-contact';
	$(base, context).each(function(){
		var component = $(this);
		var positions = component.find('.b-tabs-tab');
		var map = $('.b-map');

		positions.on('click', function() {
			var coord = $(this).data('coord');
			map.trigger('setAddress', [coord]);
		});
	});
});
